export const INVOICE_STATUS = {
    PAID: 'paid',
    UNPAID: 'unpaid',
    DRAFT: 'draft',
};
